import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Successfulprojects() {
  return (
    <section
      className="successful_projects mobile_app_case_sec p-100"
      id="case_btn"
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10}>
            <h2>
              Apps That Drive Impact: <span>Our Development Portfolio</span>
            </h2>
            <p>
              Our mobile app development company’s portfolio showcases the
              expertise we have in delivering revolutionary applications that
              drive business growth and results.{" "}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1.3,
                },
                1366: {
                  slidesPerView: 1.4,
                },
                1600: {
                  slidesPerView: 1.6,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/mobile-app/mobius_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={278}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Mobius Risk Group's Risk Management Revolution</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>30%</h5>
                        <p>efficiency increase</p>
                      </div>
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>user satisfaction boost</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/mobius"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/mobile-app/mobius_mob.webp"
                      alt="pure plank"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/mobile-app/kinder_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={278}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Transforming Energy Management with Kinder</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>25%</h5>
                        <p>ROI boost</p>
                      </div>
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>customer engagement improvement</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/projects"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/mobile-app/kinder_mob.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/onsite_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={161}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bridging the Gap between Local Residents Leveraging
                        Real-time Locations
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>55%</h5>
                        <p>Improvement in Connections</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/onsite"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/iphone-new/onsite.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/mobile-app/mobius_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={278}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Mobius Risk Group's Risk Management Revolution</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>30%</h5>
                        <p>efficiency increase</p>
                      </div>
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>user satisfaction boost</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/mobius"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/mobile-app/mobius_mob.webp"
                      alt="pure plank"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/mobile-app/kinder_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={278}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Transforming Energy Management with Kinder</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>25%</h5>
                        <p>ROI boost</p>
                      </div>
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>customer engagement improvement</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/projects"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/mobile-app/kinder_mob.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/onsite_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={161}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bridging the Gap between Local Residents Leveraging
                        Real-time Locations
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>55%</h5>
                        <p>Improvement in Connections</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/onsite"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/iphone-new/onsite.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successfulprojects;
